<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "Index",
  methods: {},
  components: {},
}
</script>

<style lang="scss">
:root,
body {
  margin: 0;
  padding: 0;
  scroll-behavior: smooth;
}
#app {
  padding: 72px 0 0 0;
}
</style>
